// =============================================================================
// app/src/lib/tipoSugerido.ts — o tipo da peça pelo começo do nome.
//
// A ADR-009 prometeu: "o formulário sugere pela primeira palavra da
// descrição". Sem isso, a peça cadastrada pelo modo Rápido (o padrão) nascia
// sem tipo e sumia de "Por tipo" e "Por carro" sem aviso (revisão do #254).
//
// Só o que o nome diz SEM dúvida: "ÓLEO" sozinho não diz se é de motor ou de
// câmbio, e "ADITIVO" pode ser de combustível — aí não há sugestão, e a pessoa
// escolhe no Completo (2ª revisão do #254). A ordem importa: o primeiro que
// casa ganha, e os de câmbio vêm antes dos de motor.
// Puro: a tela pergunta, o teste confere.
// =============================================================================

const REGRAS: ReadonlyArray<readonly [RegExp, string]> = [
  [/^CALOTAS?\b/, 'calota'],
  [/^(PROTETOR (DE )?PARALAMA|PARA-?BARRO)\b/, 'parabarro'],
  [/^(JOGO DE )?TAPETES?\b/, 'tapete'],
  [/^(EMBLEMA|LETREIRO)\b/, 'emblema'],
  [/^ANTENA\b/, 'antena'],
  [/^ADESIVO\b/, 'adesivo'],
  [/^PALHETAS?\b/, 'palheta'],
  // Óleo: câmbio, direção e diferencial antes do de motor.
  [/^OLEO (DE |PARA )?(CAMBIO|DIRECAO|DIFERENCIAL)\b/, 'oleo_cambio'],
  [/^OLEO (ATF|DEXRON|HIDRAULICO|GEAR)\b/, 'oleo_cambio'],
  [/^OLEO (SAE )?(75|80|85)W/, 'oleo_cambio'],
  [/^OLEO (SAE )?(90|140)\b/, 'oleo_cambio'],
  [/^OLEO (DE |PARA )?MOTOR\b/, 'oleo_motor'],
  [/^OLEO (SAE )?(0|5|10|15|20|25)W/, 'oleo_motor'],
  [/^ADITIVO (DE |PARA )?RADIADOR\b/, 'aditivo_radiador'],
  [/^FLUIDO (DE |PARA )?FREIO\b/, 'fluido_freio'],
  [/^AGUA DESMINERALIZADA\b/, 'agua_desmineralizada'],
  [/^ARLA\b/, 'arla32'],
  [/^FILTRO (DE |DO )?OLEO\b/, 'filtro_oleo'],
  [/^FILTRO (DE |DO )?AR\b/, 'filtro_ar'],
  [/^FILTRO (DE |DO )?COMBUSTIVEL\b/, 'filtro_combustivel'],
  [/^LAMPADAS?\b/, 'lampada'],
  [/^CABOS? (DE )?(IGNICAO|VELAS?)\b/, 'cabo_ignicao'],
  [/^(KIT (DE )?)?EMBREAGEM\b/, 'embreagem'],
  [/^BUZINAS?\b/, 'buzina'],
  [/^(SHAMPOO|LAVA AUTOS)\b/, 'lavagem'],
  [/^CERA\b/, 'cera'],
  [/^LIMPA VIDROS?\b/, 'vidros'],
  [/^(PRETINHO|RENOVADOR DE PLASTICOS?)\b/, 'plasticos_pneus'],
];

const normalizar = (s: string) =>
  s.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/\s+/g, ' ').trim();

/**
 * O tipo pelo começo do nome, se ele existe na lista de tipos do banco;
 * null quando o nome não diz com certeza (aí a pessoa escolhe no Completo).
 */
export function sugerirTipo(descricao: string, existentes: ReadonlyArray<{ slug: string }>): string | null {
  const nome = normalizar(descricao);
  if (!nome) return null;
  for (const [regra, slug] of REGRAS) {
    if (regra.test(nome)) return existentes.some((t) => t.slug === slug) ? slug : null;
  }
  return null;
}
